export const visit = (vm, at) => {
at({ "es": { "priceComponents": { "pricePerMonth": "{{price}}/mes", "pricePerMonthPerSeat": "{{price}}/mes/licencia", "subtexts": { "startsAt": "Desde" } } } });
};